




































import { parseISO, subDays } from 'date-fns';
import DatePicker from '@reciprocity/date-picker';

const TODAY = new Date();

export default {
  name: 'DateRange',
  components: { DatePicker },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  methods: {
    startDisableDates(date) {
      return date < subDays(TODAY, 1);
    },
    endDisableDates(date) {
      return (this.form.startDate && date < parseISO(this.form.startDate)) || date < subDays(TODAY, 1);
    },
    onStartDateChanged() {
      if (this.form.endDate && this.form.startDate && parseISO(this.form.startDate) > parseISO(this.form.endDate)) {
        this.form.endDate = null;
      }
    },
  },
};
